@if (showLoadingBar()) {
  <p-progressbar
    class="absolute top-0 left-0 w-full"
    [style]="{ height: '4px' }"
    mode="indeterminate"
  />
}
